import Footer from "../components/Footer";
import Hero from "../components/Hero";
import notFoundBg from '../assets/images/404.png';
import Button from "../components/Button";
function NotFound() {
    return (
        <>
            <Hero bgimg={notFoundBg} content="Not found, error 404" title="Oh-ho!" />
            <div className="container mt-5">
                <div className="row">
                    <h5>You've ventured into an unrecognized zone, a part of the system we haven't mapped yet. Maybe you've discovered a hidden feature… or just a missing route. Either way, it seems this page doesn't exist in our current build. Let's roll back to safety; the homepage is just a click away.</h5>

                    <div className="text-center mt-4">
                        <a href="/">
                            <Button type="button" content="Home" className="btn btn-primary btn-sm px-3" />
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default NotFound;
